import { ButtonStyle } from "@shared/components";
import { ReactElement } from "react";

export enum ModalSize {
  NORMAL = "normal",
  LG = "lg",
  XLG = "xlg",
  RESIZABLE = "resizable",
}

export interface ModalComponent {
  type: string;
  draggable?: boolean;
  resizable?: boolean;
  closeIcon?: boolean;
  size?: ModalSize;
  className?: string;
  props: {
    onClose?: () => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSuccess?: (value?: any) => void;
    heading?: string;
    content?: ReactElement | string;
    secondContent?: ReactElement | string;
    cancelBtnText?: string;
    successBtnText?: string;
    successBtnStyle?: ButtonStyle;
    cancelBtnStyle?: ButtonStyle;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
  };
}
